angular.module('app.factories').factory('windowDimensions', ($window) => ({
    height() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    },

    width() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },
}));
